import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-text"
}
const _hoisted_2 = { class: "px-2 d-block" }
const _hoisted_3 = {
  key: 1,
  class: "p-2"
}
const _hoisted_4 = {
  key: 2,
  class: "mt-2 mb-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("small", { class: "px-2 d-block text-light" }, " No es requerido ingresar variables para este campo ", -1)
const _hoisted_6 = {
  key: 2,
  class: "px-2 d-flex flex-wrap"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-2 mb-3"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("small", { class: "px-2 d-block text-light" }, " No es requerido ingresar variables para este campo ", -1)
const _hoisted_9 = {
  key: 3,
  class: "px-2"
}
const _hoisted_10 = { class: "small" }
const _hoisted_11 = { class: "w-100 my-2 d-flex justify-content-end" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-secondary btn-sm"
}, " Limpiar ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary btn-sm"
}, "Enviar", -1)

import { Component, Template } from "@/types/templates";
import { Form } from "vee-validate";
import FileInput from "@/components/Inputs/FileInput.vue";
import PreviewComponent from "./preview.vue";
import { MessageFilePayload } from "vue-advanced-chat";
import * as yup from "yup";
import { ref } from "vue";
import { AlertModule } from "@/store/modules/Alert";
import { FilesModule } from "@/store/modules/Files";
import { IMessage, Parameter, TemplatePayload } from "@/types/messages";
import { MessageModule } from "@/store/modules/Message";
import { AuthModule } from "@/store/modules/Auth";
// Props

export default /*#__PURE__*/_defineComponent({
  props: {
    template: null,
    activeScrollbar: { type: Boolean }
  },
  emits: ["template-sended"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "template-sended"): undefined;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	template?: Template;
	activeScrollbar?: boolean;
}



// Emits


// Data
const show = ref(false);
const preview = ref<Partial<MessageFilePayload> | null>(null);
const form = ref<any | null>(null);
// functions
function freeMemory() {
	if (preview.value?.localUrl) URL.revokeObjectURL(preview.value?.localUrl);
}
function countVariables(content: string) {
	const result = content.split(/{{\d{1,2}}}/);
	return result.length - 1;
}
function handlePreview(files?: MessageFilePayload[]) {
	show.value = true;
	if (files?.length) {
		const src = URL.createObjectURL(files[0] as any);
		preview.value = files[0];
		preview.value.localUrl = src;
	}
}
async function loadPreview(files?: MessageFilePayload[] | string) {
	const { valid } = await form.value.validate();
	if (!valid)
		return AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error variables no proveidas`,
			type: "error",
		});
	if (files && typeof files !== "string") handlePreview(files);
	show.value = true;
}
const fileValidator = (format: Component["format"]) =>
	yup.array().test(`test-${format}`, "", async function (value: any) {
		if (!value)
			return this.createError({
				path: this.path,
				message: "Debe seleccionar un archivo",
			});
		const val = (await value) as MessageFilePayload[];
		if (val.length > 1)
			return this.createError({
				path: this.path,
				message: "Solo puede subir un archivo",
			});
		const valid = val?.every(f =>
			new RegExp(
				format === "DOCUMENT" ? "(application|pdf)" : format ?? "",
				"gi"
			).test(f.type)
		);
		return (
			valid ||
			this.createError({
				path: this.path,
				message: `Seleccione un recurso en formato '${format}'`,
			})
		);
	});
function getType(type: string) {
	return /(image|png|jpg|webp|gif)/.test(type)
		? "image"
		: /(video|mp4|avi|mkv)/.test(type)
		? "video"
		: "document";
}
async function getHeaderParameters(
	payload: MessageFilePayload[] | string
): Promise<Parameter> {
	if (typeof payload === "string")
		return {
			type: "text",
			text: payload,
		};
	const type = getType(payload[0].type);
	return {
		type,
		[type]: {
			...(
				type === 'document'
					? { filename: payload[0].name }
					: {}
			),
			link: (await FilesModule.uploadSingleFile(payload[0])).data.url,
		},
	};
}
async function handleSubmit(
	data: Record<string, string | MessageFilePayload[]>
) {
	const body = props.template?.components
		.find(c => c.type === "BODY")
		?.text.split(/{{\d{1,2}}}/);
	const header = props.template?.components.find(c => c.type === "HEADER");
	const buttons = props.template?.components.find(c => c.type === "BUTTONS");

	const payload: TemplatePayload = {
		id: props.template?.id ?? "",
		namespace: props.template?.namespace ?? "",
		language: {
			policy: "deterministic",
			code: props.template?.language ?? "",
		},
		name: props.template?.name ?? "",
		components: [] as any[],
	};
	const message: Partial<IMessage["body"]> = {};
	if (data["HEADER"]) {
		const headerParam = await getHeaderParameters(data["HEADER"]);
		payload.components.push({
			type: "header",
			parameters: [headerParam],
		});
		if (headerParam.type === "text")
			message.header = header?.text
				.split(/{{\d{1,2}}}/)
				.splice(1, 0, headerParam.text ?? "")
				.join()
				.trim();
		else
			message.attachment = {
				name: (data["HEADER"][0] as MessageFilePayload).name,
				type: headerParam.type,
				url: headerParam[headerParam.type as keyof Parameter]?.link as string,
			};
	} else if (header) {
		message.header = header.text;
	}
	if (data["BODY"])
		payload.components.push({
			type: "body",
			parameters: Object.values(data["BODY"])?.map(param => ({
				type: "text",
				text: param,
			})),
		}),
			(message.text =
				body
					?.reduce((acc, curr, i) => acc + curr + (data["BODY"][i] ?? ""), "")
					.trim() ?? "");
	else if (body?.length) message.text = body[0];
	if (buttons?.buttons) {
		message.attachment = {
			type: "buttons",
			buttons: buttons.buttons.map((tempBtn, i) => ({
				type: tempBtn.type,
				title: tempBtn.text,
				value: i.toString(),
			})),
		};
	}
	MessageModule.sendTemplate({
		message,
		template: payload,
		token: AuthModule.token ?? "",
	});
	emits("template-sended");
}

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(), _createBlock(_component_el_col, { class: "fs-base px-3 py-2 template-item border rounded w-100 my-2" }, {
    default: _withCtx(() => [
      (__props.template)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.activeScrollbar ? 'el-scrollbar' : 'div'), {
            key: 0,
            height: __props.activeScrollbar ? '130px' : 'auto'
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_unref(Form), {
                ref_key: "form",
                ref: form,
                onSubmit: handleSubmit,
                key: __props.template.name
              }, {
                default: _withCtx(({ values }) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.template.components, (component) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${component.type}-${__props.template.name}`
                    }, [
                      (component.type !== 'BUTTONS')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(component.type), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (component.type === 'HEADER')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (component.format !== 'TEXT')
                              ? (_openBlock(), _createBlock(FileInput, {
                                  key: 0,
                                  label: `Se requiere un archivo de tipo ${component.format}`,
                                  "label-classes": "small",
                                  name: `${component.type}`,
                                  placeholder: 'Seleccionar un archivo',
                                  preview: "",
                                  validator: fileValidator(component.format)
                                }, null, 8, ["label", "name", "validator"]))
                              : (countVariables(component.text) > 0)
                                ? (_openBlock(), _createBlock(_component_base_input, {
                                    key: 1,
                                    name: `${component.type}`,
                                    type: "text",
                                    label: `Ingrese la variable del encabezado`,
                                    placeholder: component.text,
                                    validator: _unref(yup).string().required(`Ingrese la variable`),
                                    size: "sm",
                                    "small-label": ""
                                  }, null, 8, ["name", "placeholder", "validator"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createTextVNode(_toDisplayString(component.text) + " ", 1),
                                    _hoisted_5
                                  ]))
                          ]))
                        : (component.type === 'BODY')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              (countVariables(component.text) === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createTextVNode(_toDisplayString(component.text) + " ", 1),
                                    _hoisted_8
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countVariables(component.text), (variable) => {
                                return (_openBlock(), _createBlock(_component_base_input, {
                                  key: variable,
                                  name: `${component.type}.${variable - 1}`,
                                  type: "text",
                                  label: `Ingrese la variable ${variable}`,
                                  placeholder: component.text,
                                  "group-classes": "min-30",
                                  validator: 
										_unref(yup).string().required(`Ingrese la variable ${variable}`)
									,
                                  size: "sm",
                                  "small-label": ""
                                }, null, 8, ["name", "label", "placeholder", "validator"]))
                              }), 128))
                            ]))
                          : (component.type === 'FOOTER')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("p", _hoisted_10, _toDisplayString(component.text), 1)
                              ]))
                            : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-info btn-sm mr-auto",
                      onClick: ($event: any) => (loadPreview(values[`HEADER`]))
                    }, " Preview ", 8, _hoisted_12),
                    _hoisted_13,
                    _hoisted_14
                  ]),
                  _createVNode(PreviewComponent, {
                    modelValue: show.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
                    values: values,
                    template: __props.template,
                    preview: preview.value,
                    onFreeMemory: freeMemory
                  }, null, 8, ["modelValue", "values", "template", "preview"])
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["height"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})